import React from 'react';
import dayjs from 'dayjs';
import { calculateAge } from '../../Registrationform/helpers/calculateAge';
import PatientHistorySheet from './patientHistorySheet';
import CycleHistorySheet from './cycleHistorySheet';
import CycleHistoryAndStatus from './cycleHistoryAndStatus';

export const ClinicalCustomerProfile = ({ intermediateData, navigate }) => {
  console.log('ClinicalCustomerProfile', intermediateData);
  return (
    <>
      <div className="customer-profile">
        <h3>Customer Profile</h3>
        <div className="card" style={{ padding: 5 }}>
          <div className="body">
            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Wife's name:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.firstName}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>Age:</strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {calculateAge(dayjs(intermediateData.dob))}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Mobile:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.phone}
                </span>
              </div>
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>Id:</strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.id}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Occupation:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.company.occupation}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Email Id:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.email}
                </span>
              </div>
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-12"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Address:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.address}
                </span>
              </div>
            </div>

            <br />
            <br />
            <br />

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Husband's name:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.partner.firstName}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>Age:</strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {calculateAge(dayjs(intermediateData.partner.dob))}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Mobile:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.partner.phone}
                </span>
              </div>
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>Id:</strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.partner.id}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Occupation:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.partner.occupation}
                </span>
              </div>

              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Email Id:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.partner.email}
                </span>
              </div>
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginBottom: '15px' }}
            >
              <div
                className="flex col-md-12"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Address:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.partner.address}
                </span>
              </div>
            </div>

            <div
              className="row clearfix"
              style={{ alignItems: 'center', marginTop: '30px' }}
            >
              <div
                className="flex col-md-4"
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <strong style={{ flexShrink: 0, width: '100px' }}>
                  Referred By:
                </strong>
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intermediateData.referral.referringPhysician}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PatientHistorySheet intermediateData={intermediateData} />
      <CycleHistorySheet intermediateData={intermediateData} />
      <CycleHistoryAndStatus intermediateData={intermediateData} />
    </>
  );
};
